// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#payment-iframe-frame[data-v-632096e9] {
  border: none;
  width: 100%;
  height: 450px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/BookingModifyResume.vue","webpack://./BookingModifyResume.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;ACAF","sourcesContent":["\r\n#payment-iframe-frame {\r\n  border: none;\r\n  width: 100%;\r\n  height: 450px;\r\n  overflow: auto;\r\n}\r\n","#payment-iframe-frame {\n  border: none;\n  width: 100%;\n  height: 450px;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
